'use strict';

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var swUtils = require('js/lib/sw-utils');
var url = require('url');
var _ = require('underscore');
var ShapewaysView = require('./ShapewaysView');

var PARAMS = {
  // TODO: put this somewhere else since it's a standard response
  // param we send
  REPLACEMENT_EL: 'replacementEl',
  JS_DATA: 'jsData'
};

var HOST_REGEX = /shapeways\.(net|com)$/;

var DeferredComponent = ShapewaysView.extend({

  viewDefaults: {
    // If user supplies data-sw-deferred-component-once keep track here so we don't request twice
    hasAlreadyRunOnce: false,
    on:                false,
    replaceMethod: 'append'
  },

  swAttrs: {
    ROOT: 'data-sw-deferred-component',
    spinnerAttr: 'data-sw-deferred-component-spinner'
  },

  events: function() {
    var eventsHash = {};

    if(this.isAutoHandler()) {

      // Throttles events, useful for searching on keyup.
      var debounceTime = this.state.get('eventDebounce');
      if (debounceTime) {
        var debouncedMakeRequest = _.debounce(this.eventAttemptMakeRequest, debounceTime);

        eventsHash[this.state.get('on')] = function(event) {
          debouncedMakeRequest.call(this, event);
        };

      } else {
        eventsHash[this.state.get('on')] = 'eventAttemptMakeRequest';
      }
    }

    if (this.isLink()) {
      eventsHash.click = 'eventAttemptMakeRequest';
    }

    if (this.state.get('dropdown')) {
      eventsHash.change = 'eventAttemptMakeRequest';
    }

    return eventsHash;
  },

  initialize: function initialize() {
    this.setAttrValues();

    if(this.state.get('target')) {
      this.cachedElements.$target = $(this.state.get('target'));
      this.cachedElements.$spinnerTarget = this.cachedElements.$target.swFindWithSelf(swUtils.makeAttributeValueSelector(this.swAttrs.spinnerAttr));
    }

    this.undelegateEvents();
    this.delegateEvents();

    if(!this.isAutoHandler() && !this.state.get('noAuto') && !this.isLink()) {
      sw.requestIdleCallback(this.attemptMakeRequest.bind(this));
    }

    this.registerLoadEvent();

    if(this.state.get('autoDelay')) {
      var _this = this;
      var delay = parseInt(this.state.get('autoDelay'), 10);
      window.requestAnimationFrame(function() {
        _this.attemptMakeRequest();
      }, delay);
    }
  },

  // Check to see if attributes are availible that would make this an autohandler
  isAutoHandler: function isAutoHandler() {
    return this.state.get('on');
  },

  isLink: function isLink() {
    return this.$el.is('a');
  },

  registerLoadEvent: function registerLoadEvent() {
    // Listen for load event and run makeRequest
    if (this.state.get('loadEvent')) {
      sw.on(this.state.get('loadEvent'), this.makeRequest.bind(this));
    }
  },

  showSpinner: function showSpinner() {
    // We only support the loader if we have a target
    if(this.cachedElements.$target && !_.isUndefined(this.state.get('showSpinner'))) {

      // If we don't have a spinenr target make and add one to our target
      if(!(this.cachedElements.$spinnerTarget && this.cachedElements.$spinnerTarget.length)) {
        this.cachedElements.$target.append('<div ' + this.swAttrs.spinnerAttr + '><span class="sw-loading-spinner"></span></div>');

      // If we do have a spinner target take its defined class and remove it
      } else {

        // TODO: this action should be more semantic. It's not clear that you
        // remove a class to show the spinner ... but you are.
        this.cachedElements.$spinnerTarget.removeClass(this.cachedElements.$spinnerTarget.attr(this.swAttrs.spinnerAttr));
      }
    }
  },

  hideSpinner: function hideSpinner() {
    if(this.cachedElements.$spinnerTarget) {
      this.cachedElements.$spinnerTarget.remove();
    }
  },

  setAttrValues: function setAttrValues () {
    var attributes = this.$el.swDataParams('swDeferredComponent', { excludePrefix: true });
    this.state.set(attributes);
  },

  eventAttemptMakeRequest: function eventAttemptMakeRequest(e) {
    if(this.isLink() || _.isUndefined(this.state.get('noPrevent'))) {
      e.preventDefault();
    }

    // When requesting the same endpoint multiple times, empty the target
    // container
    if (this.state.get('clearBeforeRequest') && this.cachedElements.$target) {
      this.cachedElements.$target.text('');
    }

    this.attemptMakeRequest();
  },

  attemptMakeRequest: function attemptMakeRequest() {

    if(this.$el.attr('disabled')) {
      return;
    }

    // Only load this component if the userTypes match
    if (this.state.get('isLoggedIn') && !sw.data.user.isLoggedIn) {
      return;
    }

    if(this.state.get('once')) {
      if(this.state.get('hasAlreadyRunOnce')) {
        return;
      }

      this.state.set('hasAlreadyRunOnce', true);
    }

    this.makeRequest();
  },

  makeRequest: function makeRequest() {

    // Order of preference is input default value, link href
    var urlVal = this.state.get('swDeferredComponent') || this.$el.attr('href');

    // if it's a dropdown use value
    if(this.state.get('dropdown')) {
      urlVal = this.$el.val();
    }

    // Add any exisiting query params to our query
    var locationObj = url.parse(window.location.toString(), true);
    var urlObj = url.parse(urlVal, true);
    urlObj.query = _.extend(urlObj.query, locationObj.query);

    if (this.state.get('bustCache')) {
      urlObj.query = _.extend(urlObj.query, {
        cacheBuster: Date.now()
      });
    }

    this.showSpinner();

    if (this.state.get('dynamicValues')) {
      this.setAttrValues();
    }

    var data = _.extend({
        // rewrite so php can use constants
        _csrf: this.state.get('token')
      }, this.state.attributes);

    // If triggering with a change request
    // supply the input to watch for changes
    //
    // Use the value of this input as a request
    // param
    var inputName = this.state.get('inputName');
    if (inputName) {
      var extendedData = {};
      extendedData[inputName] = this.$el.val();
      data = _.extend(data, extendedData);
    }

    // If triggering with a change, you may stipulate
    // that requests only happen if the current
    // value matches a regex
    var inputPattern = this.state.get('inputPattern');
    if (inputPattern && inputName) {
      var regEx = new RegExp(inputPattern);
      if (!regEx.test(data[inputName])) {
        return;
      }
    }

    var self = this;

    // Make sure we're only sending credentials from Shapeways domains.
    var withCredentials = HOST_REGEX.test(window.location.host) && this.state.get('withCredentials');

    var ajaxOptions = {
      url: url.format(urlObj),
      type: this.state.get('method') || 'POST',
      data: data,
      xhrFields: {
        withCredentials: withCredentials
      }
    };

    // We should have a more sustainable way to add whatever headers via data attributes, but this is urgent.
    // NB: Only need this for CORS.
    if (this.state.get('xRequestedWith')) {
      _.extend(ajaxOptions, {
        headers: {
          'x-requested-with': 'XMLHttpRequest'
        }
      });
    }

    $.swAjax(ajaxOptions).done(function requestDone(data) {
      self.requestDone(data);
    });

  },

  requestDone: function requestDone(data) {
    this.hideSpinner();
    // If the response has a replacementEl param, honor it
    // otherwise we'll asume the response iteslf is the fragment (which is bad) but we
    // support it
    var fragment = data[PARAMS.REPLACEMENT_EL] ? data[PARAMS.REPLACEMENT_EL] : data;
    var jsData = data[PARAMS.JS_DATA] ? data[PARAMS.JS_DATA] : {};
    var replaceMethod = this.state.get('replaceMethod');

    if(!_.isEmpty(jsData)){
        /*
            The idea here is that we're adding data we get from the deferred component endpoint into sw.data.
            The prop might contain a dot, which we're assuming is meant to access a child property hence the use of Array.reduce
            See `RelatedProductsFragmentController` for usage. 
         */
        for(var prop in jsData){
            var obj = prop.split('.').reduce(function index(obj,i) {return obj[i];}, sw.data);
            Object.assign(obj, jsData[prop]);
        }
    }
    // Actually place the fragment in the dom
    if (this.cachedElements.$target) {
      fragment = $(fragment);
      // Send the fragment off to the view builders
      sw.trigger('sw-fragment-loaded', fragment);
      this.cachedElements.$target[replaceMethod](fragment);

    } else if (this.state.get('useNoty')) {
      var notyParams = {};

      if (!_.isUndefined(this.state.get('useNotyId'))) {
        notyParams.id = this.state.get('useNotyId');
      }

      if (!_.isUndefined(this.state.get('useNotyCloseWith'))) {
        notyParams.closeWith = [this.state.get('useNotyCloseWith')];
      }

      if (!_.isUndefined(this.state.get('useNotyLayout'))) {
        notyParams.layout = [this.state.get('useNotyLayout')];
      }

      if (!_.isUndefined(this.state.get('useNotyType'))) {
        notyParams.type = [this.state.get('useNotyType')];
      }

      if (!_.isUndefined(this.state.get('useNotySafariIframeFix'))) {
        notyParams.useNotySafariIframeFix = this.state.get('useNotySafariIframeFix');
      }

      // Content can either be displayed as a modal or as a full screen overlay.
      if (!this.state.get('useNotyFull')) {
        sw.notifications.content(fragment, notyParams);
      } else {
        sw.notifications.full(fragment, notyParams);
      }

    } else {
      fragment = $(fragment);
      // Send the fragment off to the view builders
      sw.trigger('sw-fragment-loaded', fragment);
      this.$el.replaceWith(fragment);
    }

    var doneEvent = this.state.get('doneEvent');

    if (doneEvent) {
      sw.trigger(doneEvent);
    }
  }
});

module.exports = DeferredComponent;
